import { Link } from 'react-router-dom';

interface ComicCardProps {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  status: string;
  rating: number;
  views: string;
  latestChapter?: string;
  isNew?: boolean;
}

export default function ComicCard({
  id,
  title,
  author,
  cover,
  category,
  status,
  rating,
  views,
  latestChapter,
  isNew,
}: ComicCardProps) {
  return (
    <Link
      to={`/comic/${id}`}
      className="group block cursor-pointer"
      data-product-shop
    >
      <div className="relative overflow-hidden rounded-lg bg-background-100 transition-transform duration-300 group-hover:-translate-y-1">
        <div className="aspect-[3/4] overflow-hidden">
          <img
            src={cover}
            alt={title}
            title={`${title} - 免费韩漫在线阅读`}
            className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        </div>

        {isNew && (
          <span className="absolute top-2 left-2 px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
            NEW
          </span>
        )}

        {status === '已完结' && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-foreground-900/70 text-background-50 text-xs font-medium rounded-md">
            完结
          </span>
        )}

        {status === '连载中' && !isNew && (
          <span className="absolute top-2 right-2 px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
            连载
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-foreground-950/80 to-transparent p-3">
          {latestChapter && (
            <p className="text-background-50 text-xs font-medium truncate">
              最新：{latestChapter}
            </p>
          )}
        </div>
      </div>

      <div className="mt-2 px-0.5">
        <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors duration-200">
          {title}
        </h3>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-foreground-500">{author}</span>
          <span className="flex items-center gap-0.5 text-xs text-primary-500">
            <i className="ri-star-fill text-[10px]"></i>
            {rating}
          </span>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-[11px] text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded">{category}</span>
          <span className="text-[11px] text-foreground-400">{views}阅读</span>
        </div>
      </div>
    </Link>
  );
}